import React from 'react';
import ReactDOM from 'react-dom';

import CompetitionForm from '../components/CompetitionForm';

const el = document.querySelector('#competition-form');
if (el) {
	const data = window.competition_form;
	if (data) {
		ReactDOM.render(<CompetitionForm data={data} />, el);
	}
}
